import React from "react";

const DarkModeIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path
                d="M7.0275 4.1325C6.8925 4.6125 6.825 5.115 6.825 5.625C6.825 8.685 9.315 11.175 12.375 11.175C12.885 11.175 13.3875 11.1075 13.8675 10.9725C13.0875 13.0425 11.1975 14.25 9 14.25C6.105 14.25 3.75 11.895 3.75 9C3.75 6.8025 5.0175 4.9125 7.0275 4.1325ZM9 2.25C5.2725 2.25 2.25 5.2725 2.25 9C2.25 12.7275 5.2725 15.75 9 15.75C12.7275 15.75 15.75 12.7275 15.75 9C15.75 8.655 15.72 8.31 15.675 7.98C14.94 9.0075 13.74 9.675 12.375 9.675C10.14 9.675 8.325 7.86 8.325 5.625C8.325 4.2675 8.9925 3.06 10.02 2.325C9.69 2.28 9.345 2.25 9 2.25Z"
                fill="currentColor"
            />
        </g>
    </svg>
)

export default DarkModeIcon;
